import React from 'react';
import { useIntl } from 'react-intl';

import { FloorplanIcon, ListIcon } from './icons';
import { ViewToggle, ViewToggleButton } from './styles';

interface ResourcesViewToggleProps {
  isFloorplanView: boolean;
  onShowList: VoidFunction;
  onShowFloorplan: VoidFunction;
}

/**
 * List / Floorplan switch for the resources page, sitting on one line with "My bookings" as in the
 * design. Rendered only when the building actually has a floorplan — see `useResourcesView`.
 */
export const ResourcesViewToggle = ({
  isFloorplanView,
  onShowList,
  onShowFloorplan,
}: ResourcesViewToggleProps): JSX.Element => {
  const intl = useIntl();

  return (
    <ViewToggle data-testid="resources-view-toggle" role="group">
      <ViewToggleButton
        type="button"
        data-testid="resources-view-toggle-list"
        isActive={!isFloorplanView}
        aria-pressed={!isFloorplanView}
        onClick={onShowList}
      >
        <ListIcon />
        {intl.formatMessage({ id: 'list' })}
      </ViewToggleButton>
      <ViewToggleButton
        type="button"
        data-testid="resources-view-toggle-floorplan"
        isActive={isFloorplanView}
        aria-pressed={isFloorplanView}
        onClick={onShowFloorplan}
      >
        <FloorplanIcon />
        {intl.formatMessage({ id: 'floorPlan' })}
      </ViewToggleButton>
    </ViewToggle>
  );
};
